export default [
  {
    group: 'account',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'api_key',
    scopes: ['create', 'delete', 'read', 'update'],
  },
  {
    group: 'badge',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'current_user',
    scopes: ['read'],
  },
  {
    group: 'event',
    scopes: ['create', 'delete', 'dispatch', 'read', 'search', 'sync_dispatch', 'update'],
  },
  {
    group: 'event_occurrence',
    scopes: ['approve', 'read', 'search'],
  },
  {
    group: 'expression',
    scopes: ['list', 'validate'],
  },
  {
    group: 'failed_job',
    scopes: ['delete', 'read', 'retry'],
  },
  {
    group: 'global_event',
    scopes: ['dispatch'],
  },
  {
    group: 'global_limit',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'global_rule',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'limit',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'membership',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'provider',
    scopes: ['activate', 'create', 'delete', 'list', 'read', 'search', 'switch', 'update'],
  },
  {
    group: 'provider_ewallet',
    scopes: ['read', 'top_up'],
  },
  {
    group: 'rate_schedule',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'rule',
    scopes: ['create', 'delete', 'read', 'search', 'update'],
  },
  {
    group: 'schedule_rule',
    scopes: ['create', 'delete', 'read', 'update'],
  },
]
